import { render, staticRenderFns } from "./banjiHome.vue?vue&type=template&id=0e8b46b3&scoped=true"
import script from "./banjiHome.vue?vue&type=script&lang=js"
export * from "./banjiHome.vue?vue&type=script&lang=js"
import style0 from "./banjiHome.vue?vue&type=style&index=0&id=0e8b46b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b46b3",
  null
  
)

export default component.exports